// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2tpdo","noInteraction":"EventWrapper_noInteraction__pggba"};